import { z } from 'zod';
import { DataQualityStatusSchema } from './source.js';

export const MarketPanelIdSchema = z.enum([
  'macro',
  'risk',
  'commodities',
  'fx',
  'flows',
  'sectors',
]);

export const CommandPanelSummarySchema = z.object({
  panelId: MarketPanelIdSchema,
  headline: z.string(),
  status: DataQualityStatusSchema,
  keyMetric: z.string(),
  keyValue: z.string(),
  glossaryTermId: z.string(),
  sourceIds: z.array(z.string()).min(1),
  asOf: z.string(),
});

export const CommandResponseSchema = z.object({
  asOf: z.string(),
  structuralSentence: z.string(),
  powerShifts: z.array(z.string()).max(3),
  regime: z.enum(['RISK_ON', 'NEUTRAL', 'RISK_OFF', 'CRISIS', 'UNKNOWN']),
  panels: z.array(CommandPanelSummarySchema).length(6),
  actionQueue: z.array(z.object({
    actionId: z.string(),
    action: z.string(),
    priority: z.enum(['high', 'medium', 'low']),
    rationale: z.string(),
    thesisId: z.string().optional(),
  })),
  recommendedAction: z.enum([
    'NO_ACTION',
    'RESEARCH_MORE',
    'WATCH',
    'INITIATE_STARTER',
    'ADD',
    'HOLD',
    'TRIM',
    'EXIT_THESIS_BROKEN',
    'EXIT_TARGET_REACHED',
    'RAISE_CASH',
    'REBALANCE',
  ]),
  falsifiers: z.array(z.string()).default([]),
  freshness: z.record(DataQualityStatusSchema),
  sourceCoverage: z.number().min(0).max(1),
});

export type CommandResponse = z.infer<typeof CommandResponseSchema>;
